module.exports = __webpack_public_path__ + "static/media/activity-bg.7abc8b62.png";